import React, { useState } from "react";
import "./CategoryModal.css";

const PRESET_COLORS = ["#c4553a","#d4963a","#7a9a6b","#2a7b9b","#7b4b94","#d4607a","#4a8c6f","#5a7a9b"];

export default function CategoryModal({ onClose, onSubmit, categories = [], defaultParentId = null, editCategory = null }) {
  const [name, setName] = useState(editCategory ? editCategory.name : "");
  const [color, setColor] = useState(editCategory ? editCategory.color : PRESET_COLORS[0]);
  const [parentId, setParentId] = useState(defaultParentId ? String(defaultParentId) : "");

  const isEdit    = !!editCategory;
  const parentOptions = categories.filter(c => !c.parent_id);
  const isSubcat  = !!defaultParentId;
  const parentName = isSubcat ? categories.find(c => c.id === defaultParentId)?.name : null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    if (isEdit) {
      await onSubmit({ id: editCategory.id, name: name.trim(), color });
    } else {
      await onSubmit({ name: name.trim(), color, parent_id: parentId ? parseInt(parentId) : null });
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h3>{isEdit ? "Rename Category" : isSubcat ? "New Sub-Category" : "New Category"}</h3>
        {isSubcat && !isEdit && <p className="modal-subtext">Under: <strong>{parentName}</strong></p>}
        <form onSubmit={handleSubmit}>
          <div className="modal-field">
            <label>Name</label>
            <input
              type="text"
              placeholder={isSubcat ? "Sub-category name" : "e.g. Errands"}
              value={name}
              onChange={e => setName(e.target.value)}
              autoFocus
            />
          </div>
          {!isSubcat && parentOptions.length > 0 && (
            <div className="modal-field">
              <label>Parent category (optional)</label>
              <select value={parentId} onChange={e => setParentId(e.target.value)}>
                <option value="">None (top-level)</option>
                {parentOptions.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>
          )}
          <div className="modal-field">
            <label>Color</label>
            <div className="modal-colors">
              {PRESET_COLORS.map(c => (
                <div
                  key={c}
                  className={"modal-color" + (color === c ? " active" : "")}
                  style={{ background: c }}
                  onClick={() => setColor(c)}
                />
              ))}
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-confirm">{isEdit ? "Save" : "Create"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
